import React from 'react';
import { Bug } from 'lucide-react';
import { useDebugStore } from '../../store/debugStore';
import { motion } from 'framer-motion';

export function DebugButton() {
  const { setIsVisible } = useDebugStore();
  
  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={() => setIsVisible(true)}
      className="fixed bottom-4 left-4 bg-gray-800 text-white p-2.5 rounded-full shadow-lg hover:bg-gray-700 transition-colors z-50"
      title="Open Debug Panel"
    >
      <Bug size={20} />
    </motion.button>
  );
}